import React from "react";
import WaveText from "../WaveText";

export default function MatchingHalvesGeneratorPanel({
  showMatchingHalvesGenerator, generatedMatchingHalves, showAskMe, showTemplates,
  showWordDefinitionGenerator, showWordTranslationGenerator, showTrueFalseGenerator,
  showWarmUpDiscussionGenerator, showCreateDialogueGenerator, showEssentialVocabularyGenerator,
  showLeadInActivitiesGenerator, showFourOpinionsGenerator, showCommunicativeSituationsGenerator,
  matchingHalvesInput, setMatchingHalvesInput, matchingHalvesLevel, setMatchingHalvesLevel,
  matchingHalvesMode, setMatchingHalvesMode, matchingHalvesLoading,
  handleMatchingHalvesGenerate, handleMatchingHalvesInsert, handleMatchingHalvesCancel,
}) {
  if (!((showMatchingHalvesGenerator || generatedMatchingHalves) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleMatchingHalvesCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Generate Matching Halves</span>
      </div>

      <textarea
        value={matchingHalvesInput}
        onChange={e => setMatchingHalvesInput(e.target.value)}
        placeholder={matchingHalvesMode === 'sentences'
          ? "Paste your sentences here (e.g., 'I do not ride a bike. I like to go to school.')"
          : "Enter words/phrases here (e.g., 'bike, school, rain, sandwich')"
        }
        rows={4}
        style={{
          fontSize: 15,
          padding: '12px',
          borderRadius: 8,
          border: '1.5px solid #cfcfff',
          background: '#f7fbff',
          resize: 'vertical',
          fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
          width: '100%',
          boxSizing: 'border-box',
          marginBottom: 16
        }}
      />

      <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, flex: 1 }}>
          <label style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 4 }}>Input Type</label>
          <div style={{
            display: 'flex',
            background: '#f8f9fa',
            borderRadius: 8,
            padding: 4,
            border: '1px solid #e9ecef',
            position: 'relative'
          }}>
            <div style={{
              position: 'absolute',
              top: 4,
              left: 4,
              bottom: 4,
              background: '#fff',
              borderRadius: 6,
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s ease',
              transform: matchingHalvesMode === 'sentences' ? 'translateX(0)' : 'translateX(100%)',
              width: 'calc(50% - 4px)'
            }} />
            <button
              type="button"
              onClick={() => setMatchingHalvesMode('sentences')}
              style={{
                flex: 1,
                padding: '8px 12px',
                border: 'none',
                background: 'transparent',
                borderRadius: 6,
                fontSize: 13,
                fontWeight: 500,
                color: matchingHalvesMode === 'sentences' ? '#8a2be2' : '#6c757d',
                cursor: 'pointer',
                transition: 'color 0.2s ease',
                position: 'relative',
                zIndex: 1
              }}
            >
              Ready Sentences
            </button>
            <button
              type="button"
              onClick={() => setMatchingHalvesMode('words')}
              style={{
                flex: 1,
                padding: '8px 12px',
                border: 'none',
                background: 'transparent',
                borderRadius: 6,
                fontSize: 13,
                fontWeight: 500,
                color: matchingHalvesMode === 'words' ? '#8a2be2' : '#6c757d',
                cursor: 'pointer',
                transition: 'color 0.2s ease',
                position: 'relative',
                zIndex: 1
              }}
            >
              Words Only
            </button>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, minWidth: 140 }}>
          <label style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 4 }}>CEFR Level</label>
          <select
            value={matchingHalvesLevel}
            onChange={e => setMatchingHalvesLevel(e.target.value)}
            style={{
              fontSize: 13,
              padding: '10px 12px',
              borderRadius: 8,
              border: '1.5px solid #e9ecef',
              background: '#fff',
              cursor: 'pointer',
              fontWeight: 500,
              color: '#22223b',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              transition: 'all 0.2s ease'
            }}
            onFocus={e => {
              e.target.style.borderColor = '#8a2be2';
              e.target.style.boxShadow = '0 0 0 3px rgba(138, 43, 226, 0.1)';
            }}
            onBlur={e => {
              e.target.style.borderColor = '#e9ecef';
              e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
            }}
          >
            <option value="A1">A1 - Beginner</option>
            <option value="A2">A2 - Elementary</option>
            <option value="B1">B1 - Intermediate</option>
            <option value="B2">B2 - Upper Intermediate</option>
            <option value="C1">C1 - Advanced</option>
            <option value="C2">C2 - Mastery</option>
          </select>
        </div>
      </div>

      <button
        onClick={handleMatchingHalvesGenerate}
        disabled={matchingHalvesLoading || !matchingHalvesInput.trim()}
        className={matchingHalvesLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{
          fontSize: 15,
          padding: '12px 16px',
          borderRadius: 8,
          border: 'none',
          background: matchingHalvesLoading || !matchingHalvesInput.trim() ? '#e0e0e0' : '#8a2be2',
          color: matchingHalvesLoading || !matchingHalvesInput.trim() ? '#999' : '#fff',
          fontWeight: 600,
          cursor: matchingHalvesLoading || !matchingHalvesInput.trim() ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s'
        }}
      >
        {matchingHalvesLoading ? <WaveText /> : 'Do the magic'}
      </button>

      {generatedMatchingHalves && (
        <div style={{ marginTop: 12, padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>
            Generated: Matching Halves Exercise
          </div>
          <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>
            {generatedMatchingHalves.sentences.length} sentences ready
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={handleMatchingHalvesInsert}
              className="magic-btn"
              style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}
            >
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
